<template>
  <div class="box-wrapper">
    <b-container>
      <div v-if="sefos_locale == 'sv'">
        <b-img fluid src="/img/help/se_overview.png"></b-img>
        <br />
        <b-img fluid src="/img/help/se_send.png"></b-img>
      </div>

      <div v-if="sefos_locale != 'sv'">
        <b-img fluid src="/img/help/en_overview.png"></b-img>
        <br />
        <b-img fluid src="/img/help/en_send.png"></b-img>
      </div>
    </b-container>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>
<style></style>
